"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Presentations_module_css_1 = __importDefault(require("./Presentations.module.css"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var PresentationsGridView_1 = __importDefault(require("./PresentationsGridView"));
var PresentationsListView_1 = __importDefault(require("./PresentationsListView"));
var react_admin_1 = require("react-admin");
var ra_data_simple_rest_1 = __importDefault(require("ra-data-simple-rest"));
var react_i18next_1 = require("react-i18next");
var NewPresentationModal_1 = __importDefault(require("./NewPresentationModal"));
var NewGroupModal_1 = __importDefault(require("./NewGroupModal"));
("@nordicscreen/q-play-core");
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var types_1 = require("@/Types/types");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var AccessControl_1 = __importDefault(require("../common/AccessControl"));
var ReactAdminErrorBoundry_1 = __importDefault(require("../common/ReactAdmin/ReactAdminErrorBoundry"));
function convertToTitleCase(word) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}
var dataProvider = (0, ra_data_simple_rest_1.default)("/api/list");
var store = (0, react_admin_1.localStorageStore)();
var PresentationsComponent = function (props) {
    var type = props.type;
    var _a = (0, react_1.useState)("grid"), active = _a[0], setActive = _a[1];
    var _b = (0, react_1.useState)([]), presentationGroups = _b[0], setPresentationGroups = _b[1];
    var _c = (0, react_1.useState)(false), presentationModalShown = _c[0], setPresentationModalShown = _c[1];
    var _d = (0, react_1.useState)({}), groupHasPresentations = _d[0], setGroupHasPresentations = _d[1];
    var _e = (0, react_1.useState)(false), groupModalShown = _e[0], setGroupModalShown = _e[1];
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var logger = q_play_core_1.logManager.getLogger();
    var toggleNewPresentationModal = function () {
        setPresentationModalShown(function (shown) { return !shown; });
    };
    var toggleNewGroupModal = function () {
        setGroupModalShown(function (shown) { return !shown; });
    };
    var handleGroupDeletion = function (updatedPresentationGroups) {
        setPresentationGroups(updatedPresentationGroups);
    };
    var getPresentationGroups = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response_1, responseData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ApiManager_1.default.getPresentationGroups(type)];
                case 1:
                    response_1 = _a.sent();
                    responseData = Object.keys(response_1.data).map(function (key) { return response_1.data[key]; });
                    setPresentationGroups(responseData);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    logger.error("Failed to fetch presentation groups: ", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var fetchGroupHasPresentationFlags = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ApiManager_1.default.getGroupHasPresentationFlags()];
                case 1:
                    result = _a.sent();
                    setGroupHasPresentations(result);
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    logger.error("Failed to fetch has presentation group flags", error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var refreshPresentationGroups = function () {
        getPresentationGroups();
    };
    var setView = function (newView) {
        try {
            setActive(newView);
            localStorage.setItem("activeView", newView);
        }
        catch (error) {
            logger.error("Failed to set view: ", error);
        }
    };
    (0, react_1.useEffect)(function () {
        var savedView = localStorage.getItem("activeView");
        if (savedView) {
            setActive(savedView);
        }
        getPresentationGroups();
        fetchGroupHasPresentationFlags();
    }, []);
    var resourceName = "presentations";
    switch (type) {
        case types_1.PresentationType.PLAYLIST:
            resourceName = "playlists";
            break;
        // TODO: Add template resourceName
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: Presentations_module_css_1.default.content_container },
            react_1.default.createElement("div", { className: "d-flex flex-nowrap justify-content-end mb-5" },
                react_1.default.createElement("div", { className: Presentations_module_css_1.default.presentation_actions },
                    react_1.default.createElement(AccessControl_1.default, { requiredPermissions: "global-".concat(type.toLowerCase(), "s-manager") },
                        react_1.default.createElement(q_play_components_1.Button, { text: t("New Group"), variant: "secondary", size: "small", style: { width: "122px" }, onClick: toggleNewGroupModal, dataCy: "newGroupModal" }),
                        react_1.default.createElement(NewGroupModal_1.default, { resourceType: type, isShown: groupModalShown, toggle: toggleNewGroupModal, setPresentationGroups: setPresentationGroups, presentationGroups: presentationGroups, fetchGroupHasPresentationFlags: fetchGroupHasPresentationFlags })),
                    react_1.default.createElement(AccessControl_1.default, { optionalPermissions: props.permissions.manage, resourceType: "".concat(type.toLowerCase(), "Groups") },
                        react_1.default.createElement(q_play_components_1.Button, { text: t("New ".concat(convertToTitleCase(type))), variant: "primary", size: "small", style: { width: "auto", marginLeft: "28px" }, onClick: toggleNewPresentationModal }),
                        react_1.default.createElement(NewPresentationModal_1.default, { resourceType: type, isShown: presentationModalShown, toggle: toggleNewPresentationModal }))),
                react_1.default.createElement("div", { className: "d-flex" },
                    react_1.default.createElement(q_play_components_1.Button, { variant: "empty", size: "small", onClick: function () { return setView("grid"); }, style: {
                            width: "42px",
                            height: "37px",
                            background: "var(--bs-body-bg)",
                        }, className: active == "list"
                            ? "opacity-50 " +
                                "d-flex align-items-center justify-content-center"
                            : "opacity-100 " +
                                "d-flex align-items-center justify-content-center" },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faGrid2, style: { fontSize: "28px" }, color: "var(--info-color)" })),
                    react_1.default.createElement(q_play_components_1.Button, { variant: "empty", size: "small", onClick: function () { return setView("list"); }, style: {
                            width: "42px",
                            height: "37px",
                            background: "var(--bs-body-bg)",
                            marginLeft: "17px",
                        }, className: active == "grid"
                            ? "opacity-50 " +
                                "d-flex align-items-center justify-content-center"
                            : "opacity-100 " +
                                "d-flex align-items-center justify-content-center" },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faList, style: { fontSize: "28px" }, color: "var(--info-color)" })))),
            react_1.default.createElement(react_admin_1.AdminContext, { dataProvider: dataProvider, store: store },
                react_1.default.createElement(ReactAdminErrorBoundry_1.default, { resourceName: type.toLowerCase() + "s", resourceURL: "/".concat(type.toLowerCase(), "s") },
                    react_1.default.createElement(react_admin_1.ResourceContextProvider, { value: resourceName },
                        react_1.default.createElement(react_admin_1.I18nContextProvider, { value: react_admin_1.defaultI18nProvider }, active === "grid" ? (react_1.default.createElement(PresentationsGridView_1.default, { presentationType: type, presentationGroups: presentationGroups, handleGroupDeletion: handleGroupDeletion, refreshPresentationGroups: refreshPresentationGroups, permissions: props.permissions, groupHasPresentations: groupHasPresentations, fetchGroupHasPresentationFlags: fetchGroupHasPresentationFlags })) : active === "list" ? (react_1.default.createElement(PresentationsListView_1.default, { presentationType: type, presentationGroups: presentationGroups, refreshPresentationGroups: refreshPresentationGroups, permissions: props.permissions })) : null))))),
        react_1.default.createElement("div", { id: "editorInertiaLink" })));
};
exports.default = PresentationsComponent;
